import { createSlatePlugin } from "platejs";
import { toNodeProps } from "./withNodeProps";

export const StylePlugin = createSlatePlugin({
  key: "style",
  node: {
    isElement: true,
  },
  parsers: {
    html: {
      deserializer: {
        rules: [
          {
            validNodeName: "STYLE",
          },
        ],
        toNodeProps: (params) => {
          const nodeProps = toNodeProps(params);
          return {
            ...nodeProps,
            elementAttributes: {
              ...nodeProps.elementAttributes,
              dangerouslySetInnerHTML: { __html: params.element.innerHTML },
            },
          };
        },
      },
    },
  },
});
